"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HelpTip = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _iconButton = require("../icon-button");

var _SvgBtArrowLeft = require("../svg/icons/SvgBtArrowLeft");

var _SvgBtArrowRight = require("../svg/icons/SvgBtArrowRight");

var _SvgBtDot = require("../svg/icons/SvgBtDot");

var _SvgBtClose = require("../svg/icons/SvgBtClose");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _loadStyles = _interopRequireDefault(require("load-styles"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

(0, _loadStyles.default)(".cf80e3841{background:var(--color-flomni-green-10);border-radius:var(--border-radius-def);padding:.5625rem .5rem}.c3d35e180{padding:0 .4375rem}.c2fa262ba{display:flex;align-items:center}.c575af197{margin-right:auto}.c741b1a4c{display:flex;align-items:center;margin:auto}.c57922adf{margin-left:auto}");
var styles = {
  root: 'cf80e3841',
  content: 'c3d35e180',
  'buttons-cnt': 'c2fa262ba',
  'buttons-left': 'c575af197',
  'buttons-center': 'c741b1a4c',
  'buttons-right': 'c57922adf'
};

var HelpTip = function HelpTip(props) {
  var children = props.children,
      classes = props.classes;
  var cn = (0, _useStyles.useStyles)(styles, classes);

  var _useState = (0, _react.useState)(0),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      slide = _useState2[0],
      setSlide = _useState2[1];

  var forwardHandler = (0, _react.useCallback)(function () {
    setSlide(slide + 1);
  }, [slide]);
  var backHandler = (0, _react.useCallback)(function () {
    setSlide(slide - 1);
  }, [slide]);
  var onExectSlideHandlers = (0, _react.useMemo)(function () {
    return children.length ? children.map(function (child, index) {
      return function () {
        return setSlide(index);
      };
    }) : [];
  }, [children]);
  (0, _react.useEffect)(function () {
    setSlide(0);
  }, [children]);
  if (children.length && !children[slide]) return null;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: cn.root
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.content
  }, !children.length ? children : children[slide]), !children.length ? null : /*#__PURE__*/_react.default.createElement("div", {
    className: cn.buttons.cnt
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: cn.buttons.left
  }, slide === 0 ? /*#__PURE__*/_react.default.createElement(_iconButton.IconButton, {
    color: "green",
    disabled: true
  }, /*#__PURE__*/_react.default.createElement(_SvgBtClose.SvgBtClose, null)) : /*#__PURE__*/_react.default.createElement(_iconButton.IconButton, {
    color: "green",
    onClick: backHandler
  }, /*#__PURE__*/_react.default.createElement(_SvgBtArrowLeft.SvgBtArrowLeft, null))), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.buttons.center
  }, children.map(function (child, index) {
    return /*#__PURE__*/_react.default.createElement(_iconButton.IconButton, {
      key: index,
      size: "small",
      color: 'green',
      disabled: index === slide,
      onClick: onExectSlideHandlers[index]
    }, /*#__PURE__*/_react.default.createElement(_SvgBtDot.SvgBtDot, null));
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.buttons.right
  }, slide === children.length - 1 ? /*#__PURE__*/_react.default.createElement(_iconButton.IconButton, {
    color: "green",
    disabled: true
  }, /*#__PURE__*/_react.default.createElement(_SvgBtClose.SvgBtClose, null)) : /*#__PURE__*/_react.default.createElement(_iconButton.IconButton, {
    color: "green",
    onClick: forwardHandler
  }, /*#__PURE__*/_react.default.createElement(_SvgBtArrowRight.SvgBtArrowRight, null)))));
};

exports.HelpTip = HelpTip;
HelpTip.propTypes = {
  /* component logic props */
  children: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)(_propTypes.node), _propTypes.node]).isRequired,

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
HelpTip.defaultProps = {
  classes: {}
};